import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-candy-box',
  templateUrl: './candy-box.component.html',
  styleUrls: ['./candy-box.component.scss']
})
export class CandyBoxComponent implements OnInit {

  urls = {
    'home': environment.homeUrl,
    'carpetaciudadana': environment.carpetaciudadanaUrl,
    'tramites': environment.tramitesUrl,
    'images': environment.imagesUrl
  };

  constructor() {
    //Empty Function
  }

  ngOnInit(): void {
    //Empty Function
  }
}